import { post } from '@/utilitys/gecAxios'
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    courseInfo: {
      type: Object,
      required: true
    }
  },
  computed: {

  },
  data () {
    return {
      showMask: true,
      isFinish: null,
      autoNext: false,
      speedList: [
        {
          key: 0,
          label: '0.5x',
          value: 0.5
        },
        {
          key: 1,
          label: '1.0x',
          value: 1
        },
        {
          key: 2,
          label: '1.25x',
          value: 1.25
        },
        {
          key: 3,
          label: '1.5x',
          value: 1.5
        },
        {
          key: 4,
          label: '2.0x',
          value: 2
        }
      ],
      speed: ''
    }
  },
  updated () {
    if (this.isFinish === null) {
      if (this.courseInfo.isFinish) {
        this.isFinish = true
      }
    }
  },
  mounted () {
    console.log('this video data', this.courseInfo.isFinish)
    this.$refs.currentVideo.addEventListener('pause', async () => {
      // 获取当前播放到的时间，并向后端请求
      const CURRENT_TIME = parseInt(this.$refs.currentVideo.currentTime)
      console.log(CURRENT_TIME)
      const { data: res } = await post(
        '/studyProgress/record',
        {
          courseId: this.$route.query.courseId,
          childCourseId: this.$route.query.childId,
          time: CURRENT_TIME
        })
      if (res.error.returnCode !== 0) return this.$Message.error('提交播放进度失败!')
      // const DATA = res.data
      // console.log('哈哈哈', DATA)
    })
    this.$refs.currentVideo.addEventListener('ended', async () => {
      // 获取当前播放到的时间，并向后端请求
      const CURRENT_TIME = parseInt(this.$refs.currentVideo.currentTime)
      const { data: res } = await post(
        '/studyProgress/record',
        {
          courseId: this.$route.query.courseId,
          childCourseId: this.$route.query.childId,
          time: CURRENT_TIME,
          type: 2
        })
      if (res.error.returnCode !== 0) return this.$Message.error('提交播放进度失败!')
      // const DATA = res.data
      // console.log('哈哈哈', DATA)
    })
  },
  methods: {
    playVideo (startAt) {
      if (startAt === 0) {
        this.releaseMask()
        this.$refs.currentVideo.currentTime = 0
        this.$refs.currentVideo.play()
      } else {
        this.$refs.currentVideo.currentTime = this.courseInfo.duration // 设置继续的位置
        this.$refs.currentVideo.play()
        this.releaseMask()
      }
    },
    releaseMask () {
      this.showMask = false
    },
    async markFinish () {
      // 标记完成
      let type = 0
      if (this.isFinish === false || this.isFinish === null) {
        this.$Modal.success({
          title: '完成',
          content: '太棒了， 您已完成本课时',
          okText: '学习下一课'
        })
        type = 2
      }
      console.log('status:0', this.isFinish)
      this.isFinish = !this.isFinish
      console.log('status:1', this.isFinish)
      // 发请求
      const CURRENT_TIME = parseInt(this.$refs.currentVideo.currentTime)
      const { data: res } = await post(
        '/studyProgress/record',
        {
          courseId: this.$route.query.courseId,
          childCourseId: this.$route.query.childId,
          time: CURRENT_TIME,
          type: type
        })
      if (res.error.returnCode !== 0) return this.$Message.error('提交播放进度失败!')
      console.log('status:2', this.isFinish)
    },
    handleChangeSpeed (value) {
      // 设置播放速度
      this.$refs.currentVideo.playbackRate = value
    },
    fommatTime (value) {
      let secondTime = parseInt(value)// 秒
      let minuteTime = 0// 分
      let hourTime = 0// 小时
      if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
        // 获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60)
        // 获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60)
        // 如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          // 获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60)
          // 获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      let result = '' + parseInt(secondTime)

      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + ':' + result
      }
      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + ':' + result
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/gecVideo/gecVideo.js